import api from '../config/api';

const notificationService = {
  async send({ title, body, pushType, productId, audience, customerId }) {
    const response = await api.post('/api/admin/notifications/send', {
      title,
      body,
      pushType: pushType || 'announcement',
      productId: productId || null,
      audience: audience || 'all',
      customerId: customerId || null,
    });
    return response.data;
  },

  async getHistory({ page = 1, pageSize = 20 } = {}) {
    const response = await api.get('/api/admin/notifications/history', {
      params: { page, pageSize },
    });
    return response.data;
  },
};

export default notificationService;
